import React from 'react';

import ModalCommonButtonsContainer from '@/components/common-components/ModalComponent/ModalCommonButtonsContainer/ModalCommonButtonsContainer';
import ArrowRight from '@/components/Icons/icons/ArrowRight';

interface Props {
  currentStep: number;
  totalSteps: number;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  isNextDisabled: boolean;
}

const NewOnboardingStepButtons = ({
  currentStep,
  totalSteps,
  handleNextStep,
  handlePreviousStep,
  isNextDisabled,
}: Props) => {
  return (
    <ModalCommonButtonsContainer
      cancelButtonText="Go Back"
      submitButtonText={
        <>
          {currentStep === totalSteps ? 'Finish & Start' : 'Next'} <ArrowRight color="white" />
        </>
      }
      onClose={handlePreviousStep}
      onSave={handleNextStep}
      showSecondaryButton={currentStep !== 1}
      primaryButtonClassName="col-start-2"
      disabled={isNextDisabled}
      disabledTooltipText="Watch the video! The 3 steps are critical for you to know."
    />
  );
};

export default NewOnboardingStepButtons;
